import { enqueueSnackbar } from "notistack";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router";
import { getProcedure } from "../../api/procedure";
import { getProcedureRole } from "../../api/procedure/getProcedureRole";
import { getStage } from "../../api/stage";
import { getQuestion } from "../../api/stage/questions";
import { Questions } from "../../components/Stages/Questions";
import { useTranslationHook } from "../../hooks";
import { setLoading } from "../../store/UI";
import { ProcedureRole } from "../../types/model/procedure";
import { Procedure } from "../../types/model/procedure/Procedure";
import { Question, Stage } from "../../types/model/stage";

const StageQuestions = () => {
  const { t } = useTranslationHook();
  const dispatch = useDispatch();

  const { accountId, projectId, activityId, procedureId, stageId } =
    useParams<{
      accountId: string;
      projectId: string;
      activityId: string;
      procedureId: string;
      stageId: string;
    }>();

  const [stage, setStage] = useState<Stage>();
  const [question, setQuestion] = useState<Question>();
  const [procedure, setProcedure] = useState<Procedure>();
  const [procedureRole, setProcedureRole] = useState<ProcedureRole>();
  const [loadingLocal, setLoadingLocal] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      if (!projectId || !activityId || !procedureId || !stageId) return;

      dispatch(setLoading(true));

      try {
        const [
          stageRes,
          questionRes,
          procedureRes,
          procedureRoleRes,
        ] = await Promise.all([
          getStage(Number(projectId), Number(activityId), Number(procedureId), Number(stageId)),
          getQuestion(Number(projectId), Number(activityId), Number(procedureId), Number(stageId)),
          getProcedure(Number(projectId), Number(activityId), Number(procedureId)),
          getProcedureRole(Number(projectId), Number(activityId), Number(procedureId)),
        ]);

        setStage(stageRes);
        setQuestion(questionRes);
        setProcedure(procedureRes);
        setProcedureRole(procedureRoleRes);

        enqueueSnackbar(t("stages.questions.questions-loaded"), {
          variant: "success",
        });
      } catch (error) {
        console.error(error);
        enqueueSnackbar(t("stages.questions.error-loading"), {
          variant: "error",
        });
      } finally {
        dispatch(setLoading(false));
        setLoadingLocal(false);
      }
    };

    fetchData();
  }, [projectId, activityId, procedureId, stageId, dispatch]);

  if (loadingLocal || !stage || !procedure || !procedureRole) return null;

  return (
    <Questions
      stage={stage}
      question={question}
      procedureRole={procedureRole}
      accountId={Number(accountId)}
      projectId={Number(projectId)}
      activityId={Number(activityId)}
      procedureId={Number(procedureId)}
      procedure={procedure}
    />
  );
};

export default StageQuestions;